import { createStore } from 'vuex';

export default createStore({
    state: {
        user: null,
        gameState: null,
        players: {},
        zombies: [],
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setGameState(state, gameState) {
            state.gameState = gameState;
        },
        updatePlayers(state, players) {
            state.players = players;
        },
        updateZombies(state, zombies) {
            state.zombies = zombies;
        },
    },
    actions: {
        async loadGameState({ commit }) {
            try {
                const response = await fetch('/api/game/state', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                const data = await response.json();
                commit('setGameState', data);
            } catch (error) {
                console.error('加载游戏状态失败:', error);
            }
        },
    },
});
